import React from 'react';
import styles from '../flabernardi_/flabernardi_.module.scss';
import Background from './src/background-links.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import HouseIcon from '../../icons/houseIcon.tsx';
import PartnershipIcon from '../../icons/partnershipIcon.tsx';
import MakeIcon from '../../icons/makeIcon.tsx';

const Flabernardi_: React.FC = () => {
    return (
        <div className={styles.flabernardi_}>
            <div className={styles["body-thunder"]} style={{
                backgroundImage: `url(${Background})`
            }}>
                <div
                    className={styles["container-thunder"]}
                >
                    <h1 className="pt-2">Flávia de Oliveira Bernardi</h1>
                    <div className={styles["redes-sociais"]}>
                        <div >
                            <a href="https://www.instagram.com/flabernardi_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                                <InstagramIcon height="22" color="#cbb353" />
                            </a>
                            <a href="https://maps.app.goo.gl/s4fbPSz8z1UBPasv8" target="_blank">
                                <MapsIcon height="27" color="#cbb353" />
                            </a>
                            <a href="https://wa.me/5517981381550" target="_blank">
                                <WhatsappIcon height="28" color="#cbb353" />
                            </a>
                        </div>
                    </div>
                    <div className={styles.links}>
                        <>
                            <LinkPersonalizado7
                                href="https://www.cmdimobiliario.com.br"
                                title="CONSULTORIA IMOBILIÁRIA"
                                icon={<HouseIcon height="32" color="#ffffff" />}
                                colorText="#cbb353"
                            />
                            <LinkPersonalizado7
                                href="https://wa.me/5517981381550?text=Olá, gostaria de mais informações sobre cursos/atendimentos."
                                title={"CURSOS ATENDIMENTOS"}
                                icon={<MakeIcon height="32" width="32" color="#ffffff" />}
                                colorText="#cbb353"
                            />
                            <LinkPersonalizado7
                                href="https://wa.me/5517981381550?text=Olá, gostaria de mais informações sobre parcerias."
                                title={"PARCERIAS"}
                                icon={<PartnershipIcon height="40" color="#ffffff" />}
                                colorText="#cbb353"
                            />
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Flabernardi_;
